import React from 'react';
import { Instagram, Linkedin, Facebook } from 'lucide-react';

export const Footer = () => {
  const footerLinks = [
    {
      title: 'About',
      links: [
        { name: 'About Us', href: '#about' },
        { name: 'Mission', href: '#mission' },
        { name: 'How We Operate', href: '#how-we-operate' },
        { name: 'UN Partner Portal', href: '#un-credibility' }
      ]
    },
    {
      title: 'Programs',
      links: [
        { name: 'Membership', href: '#membership' },
        { name: 'Closing the Gap', href: '#closing-gap-campaign' },
        { name: 'Success Path', href: '#success-path' }
      ]
    },
    {
      title: 'Get Involved',
      links: [
        { name: 'Become a Member', href: '#membership' },
        { name: 'Volunteer', href: '#get-involved' },
        { name: 'Partner With Us', href: '#get-involved' },
        { name: 'Donate', href: '#get-involved' }
      ]
    },
    {
      title: 'Resources',
      links: [
        { name: 'Blog', href: '#footer' },
        { name: 'Newsletter', href: '#footer' },
        { name: 'Events', href: '#public-events' },
        { name: 'Contact Us', href: '#footer' }
      ]
    }
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer id="footer" className="py-16" style={{ backgroundColor: 'var(--navy-muted)', color: 'white' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Logo and Brand Statement */}
        <div className="text-center mb-12">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img 
              src="/assets/lhsc-logo.png" 
              alt="The Lady Hustler Society Club" 
              className="w-32 h-auto"
              style={{ objectFit: 'contain', filter: 'brightness(0) invert(1)' }}
            />
          </div>

          {/* Brand Name */}
          <p className="lhsc-subheading text-xs text-white opacity-80 mb-6">
            INTERNATIONAL FEMALE ENTREPRENEURS & PROFESSIONALS ASSOCIATION
          </p>

          {/* Brand Statement */}
          <blockquote className="lhsc-pull-quote text-xl text-white opacity-90 max-w-2xl mx-auto">
            "We are a new breed of disruptors. We are a culture and an approach."
          </blockquote>
        </div>

        {/* Footer Links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="lhsc-heading text-sm mb-4 text-white">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="lhsc-body text-xs text-white opacity-80 hover:opacity-100 transition-opacity"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-6 mb-8">
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="opacity-80 hover:opacity-100 transition-opacity">
            <Instagram size={24} color="white" />
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="opacity-80 hover:opacity-100 transition-opacity">
            <Linkedin size={24} color="white" />
          </a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="opacity-80 hover:opacity-100 transition-opacity">
            <Facebook size={24} color="white" />
          </a>
        </div>

        {/* Credentials */}
        <div className="text-center mb-8">
          <p className="lhsc-subheading text-xs text-white opacity-80 leading-relaxed">
            REGISTERED NONPROFIT · MONTREAL, CANADA<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            UN PARTNER PORTAL<br className="md:hidden" />
            <span className="hidden md:inline"> · </span>
            GOOGLE FOR NONPROFITS
          </p>
        </div>

        {/* Legal Links */}
        <div className="flex justify-center space-x-6 mb-8">
          <a href="#footer" className="lhsc-body text-xs text-white opacity-80 hover:opacity-100 transition-opacity">
            Privacy Policy
          </a>
          <a href="#footer" className="lhsc-body text-xs text-white opacity-80 hover:opacity-100 transition-opacity">
            Terms of Service
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="lhsc-body text-xs text-white opacity-80">
            © 2026 The Lady Hustler Society Club. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
